export const painSliderCopyEs = {
    scoringHint:
        "Fíese de su primera impresión - elija el número que corresponda a lo que siente en este momento. No es necesario pensarlo demasiado.",
};
